import { DOTS } from "../../../constants"

const Dots = () => (
  <span className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700">
    {DOTS}
  </span>
)

export default Dots
